import type { $Fetch } from 'ofetch';
import type {
  DocumentoModeloGateway, ListDocumentoModelosParams,
} from '@/application/port/out/DocumentoModeloGateway';
import type { DocumentoModelo, DocumentoModeloCommand } from '@/domain/model/DocumentoModelo';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway pro CRUD admin de DocumentoModelo.
 *
 * @since G.5.3
 */
export class HttpDocumentoModeloGateway implements DocumentoModeloGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListDocumentoModelosParams): Promise<Page<DocumentoModelo>> {
    const query: Record<string, string | number> = {
      page: params.page ?? 0,
      size: params.size ?? 50,
    };
    if (params.tipo) query.tipo = params.tipo;
    const res = await this.client<ApiResponse<Page<DocumentoModelo>>>(
      '/api/v1/admin/documento-modelos', { method: 'GET', params: query });
    assertApiSuccess(res);
    return res.data;
  }

  async get(id: string): Promise<DocumentoModelo> {
    const res = await this.client<ApiResponse<DocumentoModelo>>(
      `/api/v1/admin/documento-modelos/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: DocumentoModeloCommand): Promise<DocumentoModelo> {
    const res = await this.client<ApiResponse<DocumentoModelo>>(
      '/api/v1/admin/documento-modelos', { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: DocumentoModeloCommand): Promise<DocumentoModelo> {
    const res = await this.client<ApiResponse<DocumentoModelo>>(
      `/api/v1/admin/documento-modelos/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async deactivate(id: string): Promise<void> {
    await this.client(
      `/api/v1/admin/documento-modelos/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
